import { useState } from 'react';
import { TextField } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { INPUT_STYLE, MULTILINE_INPUT_STYLE } from '../../../../../utils/styleHelpers';
import { DetailRow } from '../../../DetailsDrawer/DetailRow';

export const TextInput = (props: WidgetProps) => {
  const { value: formValue, onChange } = props;
  const [dirty, setDirty] = useState(false);
  const [value, setValue] = useState<string>(formValue || '');

  const rowCount = props.uiSchema?.['ui:rows'] || 1;

  const handleChange = (val: string) => {
    if (!dirty) setDirty(true);
    setValue(val);
    onChange(val);
  };

  const getHelperText = () => {
    if (isErrorState()) return `${props.label} required`;
    if (props.uiSchema?.['ui:help']) return props.uiSchema?.['ui:help'];
  };

  const isErrorState = () => {
    return dirty && ((props.rawErrors && props.rawErrors.length > 0) || (value === null && props.required));
  };

  if (props.readonly) {
    if (props.formContext?.hideEmpty && !formValue) return null;

    return (
      <div>
        <DetailRow
          key={props.id}
          colId={props.id}
          title={props.uiSchema?.['ui:placeholder'] || ''}
          value={formValue || ''}
        />
      </div>
    );
  }

  return (
    <>
      {props.uiSchema?.['ui:title'] && (
        <label
          htmlFor={props.id}
          className="text-gray-700"
          style={{ marginBottom: '0.5rem', display: 'block' }}>
          {props.uiSchema?.['ui:title']}
        </label>
      )}
      <TextField
        fullWidth
        value={value}
        required={props.required}
        error={isErrorState()}
        helperText={getHelperText()}
        onChange={(e) => handleChange(e.target.value)}
        key={props.uiSchema?.['ui:placeholder']}
        label={props.uiSchema?.['ui:title'] ? undefined : props.uiSchema?.['ui:placeholder']}
        placeholder={props.uiSchema?.['ui:title'] ? props.uiSchema?.['ui:placeholder'] : undefined}
        size={props.uiSchema?.['ui:size']}
        multiline={rowCount > 1}
        rows={rowCount}
        InputLabelProps={{ style: { backgroundColor: 'white', paddingRight: '.5rem' } }}
        InputProps={{ style: { fontSize: '.875rem' }, name: props.uiSchema?.['ui:placeholder'] }}
        className={`${rowCount > 1 ? MULTILINE_INPUT_STYLE : INPUT_STYLE} ${props.uiSchema?.classNames}`}
      />
    </>
  );
};
